<template>
  <div v-show="!settingUpBuddy" id="beweeg-buddy-window" :class="'beweeg-buddy-window-' + buddyData.id"
       ref="beweegBuddyWindow" :style="[getScale, centerOffset]"></div>
</template>

<script>
  import anime from 'animejs';
  import BuddyBuilder from "@/mixins/BuddyBuilder";
  import BodyPartLibrary from "@/mixins/BodyPartLibrary";

  let tinyColor = require('tinycolor2');

  export default {
    name: "Buddy",
    components: {},
    mixins: [BuddyBuilder, BodyPartLibrary],
    props: {
      containerWidth: {
        type: Number,
        default: 0
      },
      containerHeight: {
        type: Number,
        default: 0
      },
      buddyViewWidth: {
        type: Number,
        default: 0
      },
      buddyViewHeight: {
        type: Number,
        default: 0
      },
      containerSize: Object,
      buddyData: Object,
      shouldAnimate: Boolean,
      showBuddy: Boolean,
    },
    data() {
      return {
        isMounted: false,
        windowData: {},
        animating: false,
        currentAnimation: null,
        settingUpBuddy: false,
        beweegWindowWidth: null,

        //for debouncing resize event
        timeout: false, // holder for timeout id
        delay: 250, // delay after event is "complete" to run callback
      }
    },
    computed: {
      getScale() {
        return ("transform: scale(" + this.containerHeight / 300 + ");");
      },
      /*
      beweegWindowWidth() {
        if (!this.isMounted)
          return;

        if (document.querySelector('#beweeg-buddy-window')!== undefined) {
          return document.querySelector('#beweeg-buddy-window').getBoundingClientRect().width;
        } else {
          return 0;
        }
      },
      */
      centerOffset() {
        if (document.querySelector('#beweeg-buddy-window')) {
          return ("left: " + -(this.beweegWindowWidth - this.containerWidth) / 2 + "px;");
        }

        return this.containerWidth;
      },
      maxAspectRatio() {
        //if buddyView is larger than 16:9
        if (this.buddyViewWidth / this.buddyViewHeight > 1.7779) {
          return 1;
        }

        return 0;
      },
      showMaxHealthy() {
        if (this.buddyData.name == null || this.buddyData.name === "") {
          return true;
        } else {
          return false;
        }
      },
    },
    watch: {
      showBuddy: {
        handler() {
          if (this.showBuddy && this.windowData.width !== undefined && this.buddyData.bodyPartIds !== undefined && this.buddyData.bodyPartIds['head'] !== '') {
            this.setUpBuddy();
          }
        },
        deep: true,
      },
      buddyData: {
        handler() {
          if (this.showBuddy && this.windowData.width !== undefined && this.buddyData.bodyPartIds !== undefined && this.buddyData.bodyPartIds['head'] !== '') {
            this.setUpBuddy();
          }
        },
        deep: true,
      },
      windowData: {
        handler() {
          if (this.showBuddy && this.windowData.width !== undefined && this.buddyData.bodyPartIds !== undefined && this.buddyData.bodyPartIds['head'] !== '') {
            this.setUpBuddy();
          }
        },
        deep: true,
      },
      shouldAnimate: {
        handler() {
          if (this.shouldAnimate) {
            this.startAnimation();
          } else {
            this.stopAnimation();
          }
        },
      },

    },
    methods: {
      closeButton() {
        this.visible = false;
      },
      setUpBuddy() {
        this.$emit("buddyStartedLoading");
        this.settingUpBuddy = true;
        document.querySelector('#beweeg-buddy-window').innerHTML = '';

        let that = this;

        let showHealthy = false;
        if (this.showMaxHealthy || this.buddyData.fitness.colorVibrancy === "high") {
          showHealthy = true;
        }

        BuddyBuilder.buildBuddy(this.buddyData, this.windowData, showHealthy).then(function () {
          that.applyColors();
          that.createAnimationTimeline();
          that.settingUpBuddy = false;
          that.$emit("buddyLoadingFinished");
        });

      },

      applyColors() {

        let alteredColors = {};


        for (const [key, value] of Object.entries(this.buddyData.colors)) {
          if (this.buddyData.fitness.colorVibrancy === "moderate") {
            alteredColors[key] = tinyColor(value).lighten(10).toString();
          } else if (this.buddyData.fitness.colorVibrancy === "low") {
            alteredColors[key] = tinyColor(value).lighten(20).toString();
          } else {
            alteredColors[key] = value;
          }
        }

        if (!this.showMaxHealthy) {
          document.querySelectorAll('.bb_colour-0' + (1)).forEach(el => {
            el.style.fill = alteredColors['buddy_primary'];
          });
        } else {
          document.querySelectorAll('.bb_colour-0' + (1)).forEach(el => {
            el.style.fill = this.buddyData.colors['buddy_primary'];
          });
        }

        document.querySelectorAll('.bb_colour-0' + (2)).forEach(el => {
          el.style.fill = this.buddyData.colors['buddy_secondary'];
        });

        document.querySelectorAll('.bb_colour-0' + (3)).forEach(el => {
          el.style.fill = this.buddyData.colors['buddy_tertiary'];
        });

        document.querySelectorAll('.accessory_color' + (1)).forEach(el => {
          el.style.fill = this.buddyData.colors.accessory_primary;
        });

        document.querySelectorAll('.accessory_color' + (2)).forEach(el => {
          el.style.fill = this.buddyData.colors.accessory_secondary;
        });

        document.querySelectorAll('.accessory_color' + (3)).forEach(el => {
          el.style.fill = this.buddyData.colors.accessory_tertiary;
        });
      },

      createAnimationTimeline() {

        let animVal = "high";
        let postureVal = "high";

        if (!this.showMaxHealthy) {
          animVal = this.buddyData.fitness.animation;
          postureVal = this.buddyData.fitness.posture;
        }

        let animTime = 1750;

        if (animVal === "low") {
          animTime = animTime * 1.3;
        } else if (animVal === "moderate") {
          animTime = animTime * 1.2;
        }

        this.currentAnimation = anime.timeline({
          easing: 'easeOutExpo',
          duration: animTime,
          loop: true,
          direction: 'alternate'
        });

        if (postureVal === "low") {

          this.currentAnimation.add({
            targets: '.bodypartWrapper.middle',
            rotateZ: [-10, -10],
            easing: 'linear'
          })

          this.currentAnimation.add({
            targets: '.bodypartWrapper.leg_left',
            rotateZ: [10, 10],
            easing: 'linear',
          }, 0)

          this.currentAnimation.add({
            targets: '.bodypartWrapper.leg_right',
            translateY: [12, 12],
            rotateZ: [10, 10],
            easing: 'linear',
          }, 0)

          this.currentAnimation.add({
            targets: '.bodypartWrapper.arm_left',
            translateY: [3, 3],
            rotateZ: [-8, -10],
            easing: 'linear',
          }, 0)

          this.currentAnimation.add({
            targets: '.bodypartWrapper.arm_right',
            translateY: [3, 3],
            rotateZ: [14, 12],
            easing: 'linear',
          }, 0)

          this.currentAnimation.add({
            targets: '.bodypartWrapper.head',
            translateY: [10, 10],
            translateX: [-10, -10],
            rotateZ: [6, 6],
            easing: 'linear'
          })

          this.currentAnimation.add({
            targets: '.bodypartWrapper.eyes',
            translateY: [0, 12],
            scaleY: [1, 0],
            duration: 50,
            easing: 'linear',
          }, 250)

          this.currentAnimation.add({
            targets: '.bodypartWrapper.eyes',
            translateY: [12, 0],
            scaleY: [0, 1],
            duration: 100,
            easing: 'linear',
          }, 300)

          this.currentAnimation.add({
            targets: '.bodypartWrapper.ear_left',
            translateY: [6, 6],
            rotateZ: [-10, -10],
            easing: 'linear',
          }, 0)

          this.currentAnimation.add({
            targets: '.bodypartWrapper.ear_right',
            translateY: [6, 6],
            rotateZ: [10, 10],
            easing: 'linear',
          }, 0)

        }

        if (postureVal === "moderate") {

          this.currentAnimation.add({
            targets: '.bodypartWrapper.middle',
            rotateZ: [-5, -5],
            easing: 'linear'
          })

          this.currentAnimation.add({
            targets: '.bodypartWrapper.leg_left',
            rotateZ: [5, 5],
            easing: 'linear',
          }, 0)

          this.currentAnimation.add({
            targets: '.bodypartWrapper.leg_right',
            translateY: [7, 7],
            rotateZ: [5, 5],
            easing: 'linear',
          }, 0)

          this.currentAnimation.add({
            targets: '.bodypartWrapper.arm_left',
            translateY: [3, 3],
            rotateZ: [-5, -7],
            easing: 'linear',
          }, 0)

          this.currentAnimation.add({
            targets: '.bodypartWrapper.arm_right',
            translateY: [3, 3],
            rotateZ: [11, 8],
            easing: 'linear',
          }, 0)

          this.currentAnimation.add({
            targets: '.bodypartWrapper.head',
            translateY: [8, 8],
            translateX: [-3, -3],
            rotateZ: [4, 4],
            easing: 'linear'
          })

          this.currentAnimation.add({
            targets: '.bodypartWrapper.eyes',
            translateY: [0, 12],
            scaleY: [1, 0],
            duration: 50,
            easing: 'linear',
          }, 250)

          this.currentAnimation.add({
            targets: '.bodypartWrapper.eyes',
            translateY: [12, 0],
            scaleY: [0, 1],
            duration: 100,
            easing: 'linear',
          }, 300)

          this.currentAnimation.add({
            targets: '.bodypartWrapper.ear_left',
            translateY: [6, 6],
            rotateZ: [-10, -10],
            easing: 'linear',
          }, 0)

          this.currentAnimation.add({
            targets: '.bodypartWrapper.ear_right',
            translateY: [6, 6],
            rotateZ: [10, 10],
            easing: 'linear',
          }, 0)

        }

        if (postureVal === "high") {
          this.currentAnimation.add({
            targets: '.bodypartWrapper.middle',
            rotateZ: [0, 0],
            easing: 'linear'
          })

          this.currentAnimation.add({
            targets: '.bodypartWrapper.arm_left',
            rotateZ: [0, 5],
            easing: 'linear',
          }, 0)

          this.currentAnimation.add({
            targets: '.bodypartWrapper.arm_right',
            rotateZ: [0, 5],
            easing: 'linear',
          }, 0)

          this.currentAnimation.add({
            targets: '.bodypartWrapper.eyes',
            translateY: [0, 12],
            scaleY: [1, 0],
            duration: 50,
            easing: 'linear',
          }, 250)

          this.currentAnimation.add({
            targets: '.bodypartWrapper.eyes',
            translateY: [12, 0],
            scaleY: [0, 1],
            duration: 100,
            easing: 'linear',
          }, 300)
        }


      },

      startAnimation() {
        if (!this.animating) {
          this.currentAnimation.seek(0);
          this.currentAnimation.play();
          this.animating = true;
        }
      },

      stopAnimation() {
        if (this.animating) {
          //this.currentAnimation.seek(0);
          this.currentAnimation.pause();
          this.animating = false;
        }
      },

      windowResized() {
        let that = this;
        // clear the timeout
        clearTimeout(this.timeout);
        // start timing for event "completion"
        this.timeout = setTimeout(function () {
          that.windowChanged();
        }, this.delay);

      },

      windowChanged() {
        if (document.querySelector('#beweeg-buddy-window') !== undefined) {
          this.beweegWindowWidth = document.querySelector('#beweeg-buddy-window').getBoundingClientRect().width;
        } else {
          this.beweegWindowWidth = 0;
        }
      }
    },
    mounted() {
      let that = this;
      //(really) hacky way to make sure the beweegbuddy has been rendered and scaled before getting the new size
      this.$nextTick(function () {
        setTimeout(function () {
          that.isMounted = true;

          let buddyWindow = that.$el;

          that.windowData = {
            height: buddyWindow.clientHeight,
            width: buddyWindow.clientWidth,
            center: [buddyWindow.clientWidth / 2, buddyWindow.clientHeight / 2],
          }

          that.windowChanged();

        }, 50);
      });

    },
    created() {

      window.addEventListener("resize", this.windowResized);


      /*
      document.onreadystatechange = () => {
        if (document.readyState === "complete") {

          let buddyWindow = this.$el;

          this.windowData = {
            height: buddyWindow.clientHeight,
            width: buddyWindow.clientWidth,
            center: [buddyWindow.clientWidth / 2, buddyWindow.clientHeight / 2],
          }

        }
      }
      */
    },
    unmounted() {
      window.removeEventListener("resize", this.windowChanged);
    },
  }


</script>

<style lang="scss" scoped>
#beweeg-buddy-window {
  pointer-events: none;
}

</style>